import type { FaireProductEntity } from "../../entity_types/product";

export const p_mmacpu3tmw: FaireProductEntity = {
  token: "p_mmacpu3tmw",
  type: "product",
  name: "Jungle Story Tea Towel",
  brandName: "RHB HAWAII",
  imageUrl:
    "https://cdn.faire.com/fastly/430e476e9189a1f0041fa73ff5b89a925fc3412412c52b0ec817a05245d5d8cd.jpeg",
  priceDollars: 8.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/26bd1bd8a2ba7244a1bdf90c49a52b22f19d8e307d7aec153ef7883f49001e50.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
